<h1 class="mb-2"><mdb-icon fas icon="tasks"></mdb-icon> Maestro de Equivalencias</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Análisis</span>
      <span> /</span>
      <span>Maestro de Equivalencias</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow">
    <div class="card-body justify-content-between">
      <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6">
        <div></div>
        <button type="button" mdbBtn color="info" size="sm" mdbWavesEffect
          (click)="showAddEquivalencia()">Agregar</button>
      </div>

      <div class="filtros-body">
        <div class="row">
          <div class="col" style="max-width: 150px">
            <div class="md-form">
              <input value="" type="text" class="form-control" placeholder="" required
                formControlName="cliente_proveedor_rut" formatRut />
              <label for="rutproveedor">RUT Proveedor</label>
              <div
                *ngIf="formHeader.get('cliente_proveedor_rut').invalid && (formHeader.get('cliente_proveedor_rut').dirty || formHeader.get('cliente_proveedor_rut').touched)">
                <mdb-error *ngIf="formHeader.get('cliente_proveedor_rut').hasError('required')">Ingrese Proveedor
                </mdb-error>
              </div>
            </div>
          </div>
          <div class="col d-flex" style="max-width: 300px">
            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
              (click)="abrirModalSeleccionarProveedor()">
              <mdb-icon fas icon="search"></mdb-icon>
            </button>
            <h6 class="text-info" *ngIf="proveedorSeleccionado" style="display: contents">
              {{ proveedorSeleccionado.nombre }}
            </h6>
          </div>
          <div [ngClass]="{'col': true}" style="max-width: 200px;">
            <div class="md-form">
              <input value="" type="text" class="form-control" placeholder="" formControlName="sku" />
              <label for="sku">SKU Proveedor</label>
              <!-- <div>
              <mdb-error *ngIf="formHeader.get('cliente_proveedor_rut').hasError('required')">Ingrese Proveedor </mdb-error>
            </div> -->
            </div>
          </div>
          <div [ngClass]="{'col': true}" style="max-width: 300px;">
            <div class="md-form">
              <input value="" type="text" id="descripcion" class="form-control" formControlName="descripcion"
                placeholder="Descripción" #descripcion />
              <label for="descripcion">Descripción</label>
            </div>
          </div>
          <div class="col" style="display: flex; align-items: center">
            <div class="form-check my-auto">
              <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                formControlName="includeInactive" />
              <label class="form-check-label" for="flexCheckDefault"> Incluir Desactivados </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div class="resultados pl-2"></div>
      <div>
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="limpiarData()">Limpiar</button>
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar()"><mdb-icon fas icon="search"></mdb-icon>Buscar</button>
      </div>
    </div>
  </div>
</form>

<!-- Listado -->
<div class="card mb-2 wow">
  <!-- <div class="card-body d-sm-flex p-1 justify-content-end"> -->
  <div class="card-body justify-content-between">
    <div class="table">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="registros">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">SKU Proveedor</th>
            <th scope="col">Detalle proveedor</th>
            <th scope="col">Formato proveedor</th>
            <th scope="col">Factor Equivalencia</th>
            <th scope="col">SKU ERP</th>
            <th scope="col">Descripción ERP</th>
            <th scope="col">Formato ERP</th>
            <th scope="col">Estado</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="100%" style="text-align: center" *ngIf="loading">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
            <td colspan="100%" style="text-align: center" *ngIf="!loading && registros?.length === 0">No se encontró
              información</td>
          </tr>
          <tr *ngFor="let item of registros">
            <td>{{ item.producto_proveedor }}</td>
            <td>{{ item.detalle_producto }}</td>
            <td>{{ item.formato_codigo }}</td>
            <td>{{ item.factor_equivalencia | numerico }}</td>
            <td>{{ item.producto_sku }}</td>
            <td>{{ item.producto_descripcion }}</td>
            <td>{{ item.formato_descripcion_top }}</td>
            <td>
              <mdb-badge pill="true" success="true" *ngIf="item.activado">Activo</mdb-badge>
              <mdb-badge pill="true" warning="true" *ngIf="!item.activado">Inactivo</mdb-badge>
            </td>
            <td>
              <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                mdbTooltip="Editar" placement="right" (click)="loadEquivalencia(item)">
                <mdb-icon fas icon="pen"></mdb-icon>
              </button>
            </td>
            <td>
              <button mdbBtn type="button" size="sm" color="primary" mdbWavesEffect class="btn-actions-sm"
                mdbTooltip="Eliminar" placement="right" (click)="eliminarEquivalencia(item)">
                <mdb-icon fas icon="trash"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="registros?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>

<!-- MODAL equivalenciasModal -->
<app-maestro-equivalencias-modal-add-edit [optionsProveedor]="optionsProveedor" (onSuccess)="buscar(1)">
</app-maestro-equivalencias-modal-add-edit>

<!-- MODAL seleccionarProveedor -->
<app-modal-seleccionar-proveedor [multiple]="false" (onSelect)="onProveedorSeleccionado($event)" queryType="ONLY_RUT"
  showInfoProveedorInactivoBloqueado="true" (onNotFound)="onProveedorNoEncontrado()">
</app-modal-seleccionar-proveedor>